import Box from 'components/atoms/Box/Box';
import SectionProfile from 'components/templates/SectionProfile/SectionProfile';
import { apiGetPdfReport, apiPostListReport } from 'dataLayer/api/apiClient';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ROUTE_MY_PROFILE } from 'routes';

export default function RenderSectionProfile(props) {
  const dnaBeingProcessedStatuses = ['genotype-data-not-available'];
  const needsUploadStatuses = ['invalid-data-source', 'genotype-data-invalid'];
  const { traitsData, genotypeStatus } = props.data;
  const reportData = props.reportData;
  const [reportDownloadUrl, setReportDownloadUrl] = useState(undefined);

  useEffect(() => {
    let downloadUrl = undefined;
    const interval = setInterval(() => {
      apiGetPdfReport(reportData.report_code, reportData.language)
        .then((response) => {
          setReportDownloadUrl(response.download_url);
          downloadUrl = response.download_url;
        })
        .catch((err) => {
          if (err.response.status === 404) {
            apiPostListReport(reportData);
          }
        });

      if (downloadUrl || !genotypeStatus.traits_available) {
        clearInterval(interval);
      }
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  if (
    genotypeStatus.status &&
    genotypeStatus.status.includes(dnaBeingProcessedStatuses)
  ) {
    return (
      <Box textAlign="center" mb={3}>
        Your DNA is being processed!
      </Box>
    );
  } else if (
    traitsData.length <= 0 ||
    (genotypeStatus.status &&
      genotypeStatus.status.includes(needsUploadStatuses))
  ) {
    return (
      <Box textAlign="center" mb={3}>
        Please upload your DNA file <Link to={ROUTE_MY_PROFILE}>here</Link>
      </Box>
    );
  }

  return (
    <SectionProfile data={props.data} reportDownloadUrl={reportDownloadUrl} />
  );
}
